"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../style.scss");
require("../ck-content-mobile.scss");
require("./map-board-mobile.scss");
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var carousel_1 = require("../lib/carousel/carousel");
var Component_1 = require("../lib/Component");
var contants_1 = require("../lib/contants");
var map_1 = require("../lib/map/map");
var NsrAddonApi_1 = require("../lib/NsrAddonApi");
var slice_nav_1 = require("../lib/slice-nav/slice-nav");
var util_1 = require("../lib/util");
var environment_1 = __importDefault(require("../environments/environment"));
var mapLibrary$ = map_1.MapComponent.loadLibrary();
var areaCandidates = lodash_1.chunk(contants_1.AREA_FILTER_OPTIONS, 6);
var typeCandidates = contants_1.TYPE_FILTER_OPTIONS;
var MapBoard = /** @class */ (function (_super) {
    __extends(MapBoard, _super);
    function MapBoard(element) {
        var _this = _super.call(this, element) || this;
        _this.listReq$ = new rxjs_1.Subject();
        _this.fetchReq$ = new rxjs_1.Subject();
        _this.listReq$
            .pipe(operators_1.takeUntil(_this.destroy$), operators_1.switchMap(function (params) {
            _this.articles = 'loading';
            _this.pageinfo = undefined;
            _this.articleDetail = undefined;
            return NsrAddonApi_1.NsrAddonApi.listMapBoardArticle(params).pipe(operators_1.catchError(function () { return rxjs_1.EMPTY; }));
        }))
            .subscribe(function (res) {
            _this.articles = res.data;
            _this.pageinfo = res.sliceinfo;
        });
        _this.fetchReq$
            .pipe(operators_1.takeUntil(_this.destroy$), operators_1.switchMap(function (params) {
            _this.articleDetail = 'loading';
            return NsrAddonApi_1.NsrAddonApi.fetchMapBoardArticle(params).pipe(operators_1.catchError(function () { return rxjs_1.EMPTY; }));
        }))
            .subscribe(function (res) {
            _this.articleDetail = res.data;
        });
        return _this;
    }
    Object.defineProperty(MapBoard.prototype, "articles", {
        set: function (articles) {
            this._articles = articles;
            // tslint:disable-next-line: no-floating-promises
            this.renderArticles(articles);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MapBoard.prototype, "pageinfo", {
        set: function (sliceinfo) {
            this._sliceinfo = sliceinfo;
            this.renderPageNav(sliceinfo);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MapBoard.prototype, "articleDetail", {
        set: function (detail) {
            this._articleDetail = detail;
            this.renderArticleDetail(detail);
        },
        enumerable: false,
        configurable: true
    });
    MapBoard.prototype.onInit = function () {
        var _this = this;
        this.render();
        window.addEventListener('popstate', function (event) { return _this.onPopState(event); });
        var urlParams = new URLSearchParams(window.location.search);
        var area = urlParams.get('area') || '전국';
        var typesExpr = urlParams.get('types') || undefined;
        var types = typesExpr ? typesExpr.split(',') : ['대리점'];
        this.activateAreaItem(area);
        this.activateTypeItems(types);
        this.onSearch({ area: area, types: types });
    };
    MapBoard.prototype.onPopState = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var state;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = event.state || {};
                        this.activateAreaItem(state.area || '전국');
                        this.activateTypeItems(state.types || ['대리점']);
                        this.onSearch(state);
                        return [4 /*yield*/, this.setMode('list')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapBoard.prototype.onDestroy = function () { };
    MapBoard.prototype.render = function () {
        this.$board = util_1.$div('map-board', { mode: 'list' }).append(this.renderListPanel(), this.renderMainPanel());
        this.$element.empty().addClass('nsr-addon').append(this.$board);
    };
    MapBoard.prototype.renderListPanel = function () {
        return util_1.$div('list-panel d-flex flex-column').append(this.renderFilterBox(), this.renderArticlesPanel());
    };
    MapBoard.prototype.renderFilterBox = function () {
        var _a, _b;
        var _this = this;
        var $areaList = (_a = util_1.$div('area-list')).append.apply(_a, lodash_1.map(areaCandidates, function (areaLine) {
            var _a;
            return (_a = util_1.$div('d-flex flex-row')).append.apply(_a, lodash_1.map(areaLine, function (a) {
                return util_1.$div('area-item')
                    .setAttr('data-area', a)
                    .setText(a)
                    .on('click', function (ev) { return _this.onClickAreaItem(ev); });
            }));
        }));
        $areaList.findFirst('.area-item').classList.add('active');
        var $typeList = (_b = util_1.$div('type-list')).append.apply(_b, lodash_1.map(typeCandidates, function (type) {
            return util_1.$div("type-item type-item-" + type.color)
                .setAttr('data-type', type.text)
                .append(util_1.$svg('svg', 'fa', {
                'data-icon': 'check',
                viewBox: '0 0 512 512',
            }).append(util_1.$svg('path', {
                fill: 'currentColor',
                d: 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z',
            })))
                .append(util_1.$element('span').setText(type.text))
                .on('click', function (ev) { return _this.onClickTypeItem(ev); });
        }));
        $typeList.findFirst('.type-item').classList.add('active');
        return util_1.$div('filter-panel').append($areaList, $typeList);
    };
    MapBoard.prototype.renderArticlesPanel = function () {
        return util_1.$div('flex-fill articles-panel').append(util_1.$div('article-list-wrapper'), util_1.$div('page-nav-wrapper'));
    };
    MapBoard.prototype.renderArticles = function (articles) {
        return __awaiter(this, void 0, void 0, function () {
            var result, $result, $ul, _loop_1, this_1, _i, articles_1, a;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.map.beInitialized()];
                    case 1:
                        _a.sent();
                        result = this.$element.findFirst('.article-list-wrapper');
                        if (!result)
                            return [2 /*return*/];
                        $result = util_1.$helper(result).empty();
                        this.map.clearMarkers();
                        this.map.closeSingleInfoWindow();
                        if (lodash_1.isArray(articles)) {
                            if (articles.length) {
                                $ul = util_1.$element('ul', 'article-list');
                                _loop_1 = function (a) {
                                    $ul.append(this_1.renderArticle(a));
                                    if (lodash_1.isNumber(a.lat) && lodash_1.isNumber(a.lng)) {
                                        var markerImage = this_1.getMarkerImage(a.type, this_1.map);
                                        var marker = this_1.map.addMarkerAt({ lat: a.lat, lng: a.lng }, markerImage);
                                        kakao.maps.event.addListener(marker, 'click', function () {
                                            _this.carouselNavigate(a, true);
                                            _this.showInfoWindow(a);
                                        });
                                        a.marker = marker;
                                    }
                                };
                                this_1 = this;
                                for (_i = 0, articles_1 = articles; _i < articles_1.length; _i++) {
                                    a = articles_1[_i];
                                    _loop_1(a);
                                }
                                $result.append($ul);
                            }
                            else {
                                $result.append(util_1.$div('message').setText('해당하는 데이터가 없습니다'));
                            }
                        }
                        else if (articles === 'loading') {
                            $result.append(util_1.$div('loader loader-md'));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MapBoard.prototype.getMarkerImage = function (type, map) {
        switch (type) {
            case '대리점':
                return map.createMarkerImage(environment_1.default.nsr_addon_api_options.base_url + 'assets/map-marker-black.png', new kakao.maps.Size(29, 42), { offset: new kakao.maps.Point(14, 40) });
            case '샵인샵':
            case '특판점':
            case '판매점':
                return map.createMarkerImage(environment_1.default.nsr_addon_api_options.base_url + 'assets/map-marker-gray.png', new kakao.maps.Size(29, 42), { offset: new kakao.maps.Point(14, 40) });
            case '자전거길':
                return map.createMarkerImage(environment_1.default.nsr_addon_api_options.base_url + 'assets/map-marker-red.png', new kakao.maps.Size(29, 42), { offset: new kakao.maps.Point(14, 40) });
        }
        return;
    };
    MapBoard.prototype.renderPageNav = function (sliceinfo) {
        var _this = this;
        var result = this.$element.findFirst('.page-nav-wrapper');
        if (!result)
            return;
        var $result = util_1.$helper(result).empty();
        if (sliceinfo) {
            var pageNav = new slice_nav_1.SliceNavComponent(util_1.htmlDiv(), 5).init();
            pageNav.data = sliceinfo;
            pageNav.addEventListener('page-click', function (ev) { return _this.onPageRequest(ev.detail); });
            $result.append(pageNav.element);
        }
    };
    MapBoard.prototype.renderArticle = function (article) {
        var _this = this;
        return util_1.$element('li', 'article-item d-flex flex-row', { 'data-article-no': article.article_no.toString() })
            .append(util_1.$div('info flex-fill')
            .append(util_1.$div('title').setText(article.title))
            .tap(function ($) {
            if (article.addr)
                $.append(util_1.$div('addr').setText(article.addr));
            if (article.tel)
                $.append(util_1.$div('tel').setText(article.tel));
            if (article.opentime)
                $.append(util_1.$div('opentime').setText(article.opentime));
        }), util_1.$div('side')
            .append(util_1.$div('thumb')
            .tap(function ($) {
            if (article.thumb) {
                $.append(util_1.$element('img', { src: article.thumb }));
            }
            else {
                $.addClass('empty');
            }
        })
            .on('click', function () { return _this.onShowArticlesMap(article); }))
            .append(util_1.$div('btn-bordered').setText('지도').on('click', function () { return _this.onShowArticlesMap(article); })));
    };
    MapBoard.prototype.renderCarouselItem = function (article) {
        var _this = this;
        return util_1.$div('carousel-item article-item d-flex flex-row', { 'data-article-no': article.article_no.toString() })
            .append(util_1.$div('info flex-fill')
            .append(util_1.$div('title').setText(article.title))
            .tap(function ($) {
            if (article.addr)
                $.append(util_1.$div('addr').setText(article.addr));
            if (article.tel)
                $.append(util_1.$div('tel').setText(article.tel));
            if (article.opentime)
                $.append(util_1.$div('opentime').setText(article.opentime));
        }), util_1.$div('side')
            .append(util_1.$div('thumb')
            .tap(function ($) {
            if (article.thumb) {
                $.append(util_1.$element('img', { src: article.thumb }));
            }
            else {
                $.addClass('empty');
            }
        })
            .on('click', function () { return _this.onOpenArticleDetail(article); }))
            .append(util_1.$div('btn-bordered').setText('목록').on('click', function () { return _this.onShowList(); })));
    };
    MapBoard.prototype.renderMainPanel = function () {
        var _this = this;
        this.map = new map_1.MapComponent(util_1.htmlDiv('map-container'), mapLibrary$).init();
        this.carousel = new carousel_1.WkCarousel({ element: util_1.htmlDiv('articles-carousel'), dots: false, arrows: false }).init();
        this.carousel.element.addEventListener('carousel-navigate', function (event) { return _this.onCarouselNavigate(event.detail); });
        return util_1.$div('main-panel').append(this.map.element, util_1.$div('articles-carousel-container').append(this.carousel.element, util_1.$div('btn-handle btn-up')
            .append(util_1.$svg('svg', 'fa', {
            'data-icon': 'chevron-up',
            viewBox: '0 0 448 512',
        }).append(util_1.$svg('path', {
            fill: 'currentColor',
            d: 'M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z',
        })))
            .on('click', function () { return _this.onOpenArticleDetail(); }), util_1.$div('btn-handle btn-down')
            .append(util_1.$svg('svg', 'fa', {
            'data-icon': 'chevron-down',
            viewBox: '0 0 448 512',
        }).append(util_1.$svg('path', {
            fill: 'currentColor',
            d: 'M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z',
        })))
            .on('click', function () { return _this.onCloseArticleDetail(); })), util_1.htmlDiv('detail-container'));
    };
    MapBoard.prototype.renderArticleDetail = function (detail) {
        var container = this.$board.findFirst('.detail-container');
        if (!container)
            return;
        var $container = util_1.$helper(container).empty();
        if (lodash_1.isObject(detail)) {
            // $container.append($div('title').setText(detail.title));
            // if (detail.addr) $container.append($div('addr').setText(detail.addr));
            // if (detail.tel) $container.append($div('tel').setText(detail.tel));
            // if (detail.opentime) $container.append($div('opentime').setText(detail.opentime));
            if (detail.content)
                $container.append(util_1.$div('ck-content').setInnerHtml(detail.content));
        }
        else if (detail === 'loading') {
            $container.append(util_1.$div('loader loader-md'));
        }
    };
    MapBoard.prototype.activateAreaItem = function (area, target) {
        if (!target) {
            target = this.$element.findFirst(".list-panel .filter-panel .area-list .area-item[data-area='" + area + "']") || undefined;
        }
        if (target) {
            this.$element.findAll('.list-panel .filter-panel .area-list .area-item.active').forEach(function (item) {
                if (item !== target)
                    item.classList.remove('active');
            });
            target.classList.add('active');
        }
    };
    MapBoard.prototype.onClickAreaItem = function (ev) {
        return __awaiter(this, void 0, void 0, function () {
            var target, area, types, searchOptions;
            return __generator(this, function (_a) {
                target = ev.currentTarget;
                area = target.getAttribute('data-area');
                if (area) {
                    this.activateAreaItem(area, target);
                    types = this.readTypesOption();
                    searchOptions = { area: area, types: types };
                    history.pushState(searchOptions, area, "?area=" + area + "&types=" + types.join(','));
                    this.onSearch(searchOptions);
                }
                return [2 /*return*/];
            });
        });
    };
    MapBoard.prototype.toggleTypeItem = function (type, target) {
        if (!target) {
            target = this.$element.findFirst(".list-panel .filter-panel .type-list .type-item[data-type='" + type + "']") || undefined;
        }
        if (target) {
            target.classList.toggle('active');
        }
    };
    MapBoard.prototype.activateTypeItems = function (types) {
        var typeItems = this.$element.findAll('.list-panel .filter-panel .type-list .type-item');
        typeItems.forEach(function (typeItem) {
            var type = typeItem.getAttribute('data-type');
            if (type) {
                if (types.includes(type)) {
                    typeItem.classList.add('active');
                }
                else {
                    typeItem.classList.remove('active');
                }
            }
        });
    };
    MapBoard.prototype.onClickTypeItem = function (ev) {
        var target = ev.currentTarget;
        var type = target.getAttribute('data-type');
        if (type) {
            this.toggleTypeItem(type, target);
            var area = this.readAreaOption();
            var types = this.readTypesOption();
            var searchOptions = { area: area, types: types };
            history.pushState(searchOptions, area, "?area=" + area + "&types=" + types.join(','));
            this.onSearch(searchOptions);
        }
    };
    MapBoard.prototype.setMode = function (mode, initialIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var oldMode;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oldMode = this.$board.getAttr('mode');
                        if (!(mode !== oldMode)) return [3 /*break*/, 3];
                        this.$board.setAttr('mode', mode);
                        if (!(mode === 'map')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.map.beInitialized()];
                    case 1:
                        _a.sent();
                        this.map.relayout();
                        _a.label = 2;
                    case 2:
                        if (oldMode === 'list' && lodash_1.isArray(this._articles)) {
                            this.carousel.updateItems(this._articles.map(function (a) { return _this.renderCarouselItem(a).element; }), initialIndex);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MapBoard.prototype.onShowArticlesMap = function (article) {
        return __awaiter(this, void 0, void 0, function () {
            var initialIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!lodash_1.isArray(this._articles)) return [3 /*break*/, 3];
                        initialIndex = this._articles.indexOf(article);
                        return [4 /*yield*/, this.setMode('map', initialIndex)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.showMapPosition(article)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MapBoard.prototype.onShowList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setMode('list')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapBoard.prototype.onOpenArticleDetail = function (article) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!article) {
                            if (lodash_1.isArray(this._articles)) {
                                article = this._articles[this.carousel.getCurrentIndex()];
                            }
                        }
                        if (!article) return [3 /*break*/, 3];
                        if (!article.link) return [3 /*break*/, 1];
                        window.open(util_1.urlLinkPipe(article.link), '_blank');
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.setMode('detail')];
                    case 2:
                        _a.sent();
                        this.onShowArticleDetail(article);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MapBoard.prototype.onCloseArticleDetail = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setMode('map')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapBoard.prototype.readAreaOption = function () {
        var _a;
        return ((_a = this.$element
            .findFirst('.list-panel .filter-panel .area-list .area-item.active')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-area')) || '전국';
    };
    MapBoard.prototype.readTypesOption = function () {
        return lodash_1.map(this.$element.findAll('.list-panel .filter-panel .type-list .type-item.active'), function (item) {
            return item.getAttribute('data-type');
        });
    };
    MapBoard.prototype.onSearch = function (_a) {
        var area = _a.area, types = _a.types;
        var params = { types: [], limit: 1000 };
        if (area && area !== '전국')
            params.area = area;
        // 모든 타입이 체크되어 있지 않은 경우에만 타입 필터를 넣는다
        if (!(lodash_1.includes(types, '대리점') && lodash_1.includes(types, '취급점') && lodash_1.includes(types, '자전거길'))) {
            if (lodash_1.includes(types, '대리점'))
                params.types.push('대리점');
            if (lodash_1.includes(types, '취급점'))
                params.types.push('샵인샵', '특판점', '판매점');
            if (lodash_1.includes(types, '자전거길'))
                params.types.push('자전거길');
        }
        this.listReq$.next(params);
    };
    MapBoard.prototype.onPageRequest = function (ev) {
        this.listReq$.next(ev.request);
    };
    MapBoard.prototype.showMapPosition = function (article) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(article.lat && article.lng)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.map.beInitialized()];
                    case 1:
                        _a.sent();
                        this.showInfoWindow(article);
                        this.map.setLevel(4);
                        this.map.setCenter({ lat: article.lat, lng: article.lng });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    MapBoard.prototype.showInfoWindow = function (article) {
        var _this = this;
        if (article.lat && article.lng) {
            var $content = util_1.$div('info-window-article').append(util_1.$div('title').setText(article.title));
            if (article.addr)
                $content.append(util_1.$div('addr').setText(article.addr));
            if (article.tel)
                $content.append(util_1.$div('tel').setText(article.tel));
            if (article.opentime)
                $content.append(util_1.$div('opentime').setText(article.opentime));
            $content.append(util_1.$div('text-right').append(util_1.$element('a')
                .setText('더보기')
                .tap(function ($) {
                if (article.link) {
                    $.setAttr('href', util_1.urlLinkPipe(article.link)).setAttr('target', '_blank');
                }
                else {
                    $.on('click', function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.setMode('detail')];
                                case 1:
                                    _a.sent();
                                    this.onShowArticleDetail(article);
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
            })));
            this.map.createSingleInfoWindow({ lat: article.lat, lng: article.lng }, $content.element, {
                removable: true,
                marker: article.marker,
            });
        }
    };
    MapBoard.prototype.onShowArticleDetail = function (article) {
        this.fetchReq$.next({ article_no: article.article_no });
    };
    MapBoard.prototype.onCarouselNavigate = function (detail) {
        return __awaiter(this, void 0, void 0, function () {
            var article, oldMode;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!lodash_1.isArray(this._articles)) return [3 /*break*/, 3];
                        article = this._articles[detail.targetIndex];
                        if (!article) return [3 /*break*/, 3];
                        oldMode = this.$board.getAttr('mode');
                        if (!(oldMode === 'map')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.showMapPosition(article)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if (oldMode === 'detail') {
                            this.onShowArticleDetail(article);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MapBoard.prototype.carouselNavigate = function (article, animation) {
        if (lodash_1.isArray(this._articles)) {
            var targetIndex = this._articles.indexOf(article);
            if (targetIndex >= 0) {
                this.carousel.navigateSlide(targetIndex, animation);
            }
        }
    };
    return MapBoard;
}(Component_1.Component));
util_1.startOnLoaded(function () {
    console.log('Initializing nsr-addon.map-board');
    var container = document.querySelector('.nsr-addon-container');
    if (container) {
        new MapBoard(container).init();
    }
});
